<template>
    <div class="relative"
         :class="{'min-h-[300px]': isLoading}"
    >
        <div v-if="!isLoading" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 m-6">
            <div v-for="store in stores" :key="store.id"
                 class="group cursor-pointer bg-white dark:bg-gray-800 shadow rounded-lg dark:text-white flex justify-between items-center"
                 @click="$emit('click', store.id)"
            >
                <span class="py-3 px-6 group-hover:font-bold">
                    {{ store.name }}
                </span>
                <span class="p-6 group-hover:bg-gray-300 dark:group-hover:bg-gray-700 rounded-tr-lg rounded-br-lg">
                    <icon name="chevron-right" :size="6"></icon>
                </span>
            </div>
        </div>

        <loading-overlay :is-loading="isLoading"/>
    </div>
</template>

<script>
import Store from '@/Models/Store';

export default {
    data() {
        return {
            stores: [],
            isLoading: true,
        };
    },

    async created() {
        let storesResponse;
        let allStores = [];
        let currentPage = 1;
        let totalPages = 1;

        do {
            storesResponse = await Store.pageNumber(currentPage).all();
            allStores.push(...storesResponse.data);
            currentPage++;
            totalPages = storesResponse.meta.pagination.total_pages;
        } while (
            storesResponse.meta.pagination
            && currentPage <= totalPages
        );

        this.stores = allStores;
        this.isLoading = false;
    }
};
</script>
